import { useEffect, useMemo } from 'react';
import { gql, useMutation } from '@apollo/client';

import RejectedOrder from 'Components/RejectedOrder';
import { useConfig } from 'Components/ConfigProvider';

export const MARK_ORDER_AS_CONFIRMED = gql`
  mutation markOrderAsConfirmed($orderId: ID!) {
    updateOrder(id: $orderId, confirmed: true) {
      id
      confirmed
    }
  }
`;

type Props = {
  /**
   * orderId
   */
  orderId: string;
  /**
   * rejectReason
   */
  rejectReason: string;
  /**
   * onClose
   */
  onClose: () => void;
};

/**
 * Rejected component
 */
const Rejected = ({ orderId, rejectReason, onClose }: Props) => {
  const config = useConfig();

  const [mutate] = useMutation(MARK_ORDER_AS_CONFIRMED, {
    variables: { orderId },
    optimisticResponse: {
      __typename: 'Mutation',
      updateOrder: {
        id: orderId,
        __typename: 'Order',
        confirmed: true,
      },
    },
  });

  useEffect(() => {
    mutate();
  }, []);

  const description = useMemo(() => {
    switch (rejectReason) {
      case 'TOO_MANY_ORDERS':
        return 'OrderStatus.Rejected.ToMuchToDoRightNow';
      case 'OUT_OF_SUPPLIES':
        return 'OrderStatus.Rejected.EndOfGoods';
      case 'DELIVERY_IS_NOT_AVAILABLE':
        return 'OrderStatus.Rejected.DeliverNotAvailable';
      case 'CLOSING_SOON':
        return 'OrderStatus.Rejected.WeWillCloseSoon';
      default:
        return 'OrderStatus.Rejected.DefaultText';
    }
  }, [rejectReason]);

  return (
    <RejectedOrder
      onClose={onClose}
      title="Orderstatus.Rejected.Title"
      description={description}
      company={config.DISPLAY_NAME}
    />
  );
};

export default Rejected;
